import { useMemo, useState } from "react";
import { hotCategories, gridStories } from "@/mocks/baoliaoData";

export default function HotGrid() {
  const [active, setActive] = useState("all");

  const shown = useMemo(
    () => (active === "all" ? gridStories : gridStories.filter((s) => s.cat === active)),
    [active]
  );

  return (
    <section id="hot" className="py-10 md:py-16 bg-background-100/70 border-y border-background-200/60">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6">
          <div>
            <span className="inline-flex items-center gap-1.5 text-accent-600 text-xs font-semibold tracking-wider uppercase">
              <i className="ri-fire-fill"></i>
              全网热瓜
            </span>
            <h2 className="font-heading font-extrabold text-2xl md:text-3xl tracking-tight text-foreground-950 mt-1">
              今天都在吃这些瓜
            </h2>
            <p className="text-xs text-foreground-500 mt-1">按栏目浏览全网正在发酵的热门事件</p>
          </div>
          {/* category segmented control */}
          <div className="flex items-center gap-1 rounded-full border border-background-300 bg-background-50 p-1 max-w-full overflow-x-auto">
            <button
              onClick={() => setActive("all")}
              className={`px-3.5 py-1.5 text-xs rounded-full font-medium whitespace-nowrap transition-colors ${
                active === "all" ? "bg-foreground-950 text-background-50" : "text-foreground-600 hover:text-foreground-900"
              }`}
            >
              全部
            </button>
            {hotCategories.map((c) => (
              <button
                key={c.key}
                onClick={() => setActive(c.key)}
                className={`px-3.5 py-1.5 text-xs rounded-full font-medium whitespace-nowrap transition-colors ${
                  active === c.key ? "bg-foreground-950 text-background-50" : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>
        </div>

        <div key={active} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 animate-rise">
          {shown.map((story) => (
            <article
              key={story.id}
              className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 overflow-hidden hover:border-primary-200 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative overflow-hidden aspect-[16/10] w-full">
                <img
                  src={story.image}
                  alt={`${story.title} 相关配图`}
                  title={`${story.title} · ${story.cat}`}
                  className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span
                  className={`absolute top-3 left-3 inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-bold ${
                    story.tag === "爆"
                      ? "bg-primary-500 text-background-50"
                      : story.tag === "热"
                      ? "bg-accent-500 text-foreground-950"
                      : "bg-foreground-950/80 text-background-50"
                  }`}
                >
                  {story.tag === "爆" ? "全网爆瓜" : story.tag === "热" ? "持续升温" : "最新消息"}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <span className="text-[11px] text-primary-600 font-semibold mb-1.5">{story.cat}</span>
                <h3 className="font-heading font-bold text-base md:text-lg leading-snug text-foreground-950">
                  {story.title}
                </h3>
                <p className="mt-2 text-[13px] leading-relaxed text-foreground-600 flex-1 line-clamp-2">{story.summary}</p>
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/80">
                  <div className="flex items-center gap-3 text-[11px] text-foreground-500">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {story.time}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {story.views}
                    </span>
                  </div>
                  <a
                    href="#track"
                    className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 hover:text-primary-700 whitespace-nowrap"
                  >
                    追踪进展 <i className="ri-arrow-right-line text-xs"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}